import { Routes, Route, Navigate } from "react-router-dom"

import Accounts from "./Accounts"
import Brands from "./Brands"
import SubBrands from "./SubBrands"
import Categories from "./Categories"
import Home from "./Home"
import Wallet from "./Wallet"
import Offers from "./Offers"
import Orders from "./Orders"
import Transactions from "./Transactions"

import Header from "../../components/Shared/Header"


function Admin(props) {
    return (
        <div className="h-full text-white">
            <Header />
            <main style={{"height": "calc(100% - 78px)"}}>
                <Routes>
                    <Route path="home" element={<Home />} />
                    <Route path="vendors" element={<Wallet />} />
                    <Route path="wallet" element={<Navigate to="/admin/vendors" replace />} />
                    <Route path="brands" element={<Brands />} />
                    <Route path="sub-brands" element={<SubBrands />} />
                    <Route path="categories" element={<Categories />} />
                    <Route path="orders" element={<Orders />} />
                    <Route path="transactions" element={<Transactions />} />
                    {/* <Route path="offers" element={<Offers />} /> */}
                    {/* <Route path="accounts" element={<Accounts />} /> */}
                    <Route path="*" element={<Navigate to="/admin/home" replace />} />
                </Routes>
            </main>
        </div>
    );
}

export default Admin;